module.exports = {
  eventCategory: 'Editor UI | Top Menu',
  eventAction: 'versions',

  loadVersion: function (event) {
    var versionId = $(event.currentTarget).attr('data-versionId');
    this.trackEvent({ eventLabel: 'versionId_' + versionId });
  }

};
